import { Sparkles, Check } from "lucide-react";

/**
 * Premium coded "Voice AI answering" mockup: an AI agent picking up an after-hours
 * call, transcribing, and booking the job. Hero visual for the Enterprise AI page;
 * sells 24/7 instant answer without a stock robot image.
 */
const wave = [6, 11, 8, 16, 22, 14, 9, 18, 24, 13, 8, 15, 20, 10, 7, 12];

export const VoiceAIMockup = () => {
  return (
    <div className="relative w-full max-w-[400px] mx-auto select-none">
      {/* soft brand glow */}
      <div className="absolute -inset-8 -z-10 bg-[radial-gradient(circle_at_70%_25%,rgba(244,63,94,0.18),transparent_60%),radial-gradient(circle_at_25%_85%,rgba(168,85,247,0.16),transparent_60%)] blur-2xl" />

      {/* floating badge */}
      <div className="absolute -top-3 right-4 z-10 rounded-full bg-gradient-to-br from-rose-600 to-rose-500 px-3.5 py-1.5 text-xs font-bold text-white shadow-lg shadow-rose-900/20">
        Answered in 3 sec
      </div>

      <div className="relative overflow-hidden rounded-[1.75rem] border border-black/[0.06] bg-white shadow-2xl shadow-rose-900/10">
        {/* call header */}
        <div className="flex items-center gap-2.5 border-b border-slate-100 px-4 py-3.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-400 opacity-75 motion-reduce:hidden" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-rose-500" />
          </span>
          <span className="text-sm font-bold text-slate-900">Incoming call</span>
          <span className="ml-auto text-xs font-medium text-slate-600">2:47 AM</span>
        </div>

        {/* AI agent + live waveform */}
        <div className="flex items-center gap-3 px-4 pt-4">
          <div className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-rose-500 to-fuchsia-500 text-white shadow-md shadow-rose-500/30">
            <Sparkles className="h-4 w-4" />
          </div>
          <div className="flex h-8 flex-1 items-center gap-[3px]">
            {wave.map((h, i) => (
              <div key={i} className="w-[3px] rounded-full bg-rose-400/70" style={{ height: `${h * 1.4}px` }} />
            ))}
          </div>
        </div>
        <div className="px-4 pb-1 pt-1.5 text-xs font-semibold text-rose-600">Frayze AI &middot; answering</div>

        {/* transcript */}
        <div className="space-y-2.5 px-4 py-3">
          <div className="flex justify-start">
            <div className="max-w-[82%] rounded-2xl rounded-bl-md bg-slate-100 px-3.5 py-2 text-xs font-medium leading-relaxed text-slate-700">
              Do you handle emergency furnace repairs?
            </div>
          </div>
          <div className="flex justify-end">
            <div className="max-w-[82%] rounded-2xl rounded-br-md bg-gradient-to-br from-rose-600 to-rose-500 px-3.5 py-2 text-xs font-medium leading-relaxed text-white shadow-sm">
              We do. I can have a tech at your door by 8 AM. What&rsquo;s the address?
            </div>
          </div>
        </div>

        {/* action footer */}
        <div className="flex items-center gap-2 border-t border-slate-100 bg-slate-50/60 px-4 py-2.5">
          <Check className="h-3.5 w-3.5 text-emerald-500" />
          <span className="text-xs font-medium text-slate-500">Appointment booked &middot; CRM updated</span>
        </div>
      </div>
    </div>
  );
};

export default VoiceAIMockup;
